<template lang="html">
  <div class="editor component mapEditor">
  	<div class="container stage-container"></div>
  	<div class="controls float-panel">
  		<div class="controls-group" v-if="!isFilePrefab">
  			<label class="title">Tilemap Properties</label>
  			<div style="padding: 0 10px 10px 10px;">
  				<label>Tilemap</label>
  				<select v-model="scene.tilemap" @change="updateTilemap()">
  					<option value="">None</option>
  					<option v-for="tilemap in tilemaps" :key="tilemap.name">{{tilemap.name}}</option>
  				</select>
  				<label>Pix Size</label>
  				<div class="input-group" style="width: 64px;margin-right: 7px;">
  					<input type="text" v-model="scene.tilemapPixSize" @input="updateTilemap()">
  					<span class="input-group-append">px</span>
  				</div>
  			</div>
  		</div>
  		<div class="controls-group game-object-list" v-if="!isFilePrefab">
  			<label class="title">Game Objects</label>
        <DraggableList :items="scene.gameObjects" class="select" @change="selectedGameObjectIndex = $event.newIndex;updateNewStage()">
          <template v-slot:item="{ item, index }">
            <div class="option" :class="{'selected': selectedGameObjectIndex == index}" @click="selectedGameObject = item;selectedGameObjectIndex = index;updateNewStage()" @dblclick="focusGameObject(item)">
              <span>{{item.name}}</span>
              <i :class="item.visible ? 'icon-visibility' : 'icon-visibility_off'" @click="item.visible = !item.visible;updateNewStage()"></i>
              <i :class="item.locked ? 'icon-lock' : 'icon-lock_open'" @click="item.locked = !item.locked;updateNewStage()"></i>
            </div>
          </template>
        </DraggableList>
  			<div class="select-controls">
  				<button type="button" class="btn-icon" title="New" @click="goNew()"><i class="icon-note"></i></button>
  				<button type="button" class="btn-icon" title="Duplicate" @click="goDuplicate()" v-if="selectedGameObject"><i class="icon-copy"></i></button>
  				<button type="button" class="btn-icon" title="Delete" @click="goDelete()" v-if="selectedGameObject"><i class="icon-delete"></i></button>
  			</div>
  		</div>
  	</div>
  	<StageGameObjectProperties :game-object="selectedGameObject" @render="updateNewStage()" />
  </div>
</template>

<script>
import StageGameObjectProperties from '@/assets/components/stage/GameObjectProperties.vue';
import DraggableList from '@/assets/components/DraggableList.vue';
const Util = window.Util;
const UtilMath = window.UtilMath;
import GameStudio from '@/assets/js/GameStudio.js'
const TilemapViewer = window.TilemapViewer;

export default {
  props: ['fileData'],
  components: {
    StageGameObjectProperties,
    DraggableList
  },
  data: function () {
    var assets = GameStudio.getFilesWithExtensions(['.png', '.jpg']).toNameData();
    return {
  		isFilePrefab: this.fileData.name.match(new RegExp('(' + Util.escapeRegExp('.prefab') + ')$', 'i')),
  		scene: this.fileData.data,
  		tilemaps: GameStudio.getFilesWithExtensions(['.tilemap']),
  		selectedGameObject: null,
      selectedGameObjectIndex: null,
      /* other */
      tilemapViewer: null,
      assets: assets,
      cacheImages: null,
      stageCanvas: null,
      stageCtx: null,
      camera: {x: 0, y: 0},
      goMap: [],
      isUpdateRequested: false
  	};
  },
	methods: {
		goNew: function () {
			var gameObject = GameStudio.createGameObject();
			this.scene.gameObjects.push(gameObject);
      this.updateNewStage();
		},
		goDuplicate: function () {
			var gameObject = Util.jsonClone(this.selectedGameObject);
			this.scene.gameObjects.push(gameObject);
      this.updateNewStage();
		},
		goDelete: function () {
			this.scene.gameObjects.splice(this.selectedGameObjectIndex, 1);
			this.selectedGameObject = null;
			this.selectedGameObjectIndex = null;
      this.updateNewStage();
		},
		updateTilemap: function () {
			this.tilemapViewer.tilemap = (this.tilemaps.find(t => t.name === this.scene.tilemap) || {}).data;
			this.tilemapViewer.pixSize = parseInt(this.scene.tilemapPixSize);
			this.updateNewStage();
		},
    /*========================================================================*/
    createNewStage: function () {
    	if (this.isFilePrefab) return;
      console.log('createNewStage');
      var self = this;
      var camera = this.camera;
    	var container = this.$el.querySelector('.stage-container');
    	container.innerHTML = '';
    	var stageCanvas = this.stageCanvas = container.appendChild(document.createElement('canvas'));
    	stageCanvas.width = window.innerWidth;
    	stageCanvas.height = window.innerHeight;
    	Util.canvasDisableImageSmoothing(stageCanvas);
    	this.stageCtx = stageCanvas.getContext('2d');
    	this.updateTilemap();

    	var offset = {x: 0, y: 0};
    	var move = function (event) {
    		var rect = stageCanvas.getBoundingClientRect();
    		var mousePosition = {
    			"x": Math.trunc(event.clientX - rect.x + camera.x),
    			"y": Math.trunc(event.clientY - rect.y + camera.y)
    		};
    		if (['touchstart', 'touchmove'].indexOf(event.type) !== -1) {
    			mousePosition = {
    				"x": Math.trunc(event.touches[0].clientX - rect.x + camera.x),
    				"y": Math.trunc(event.touches[0].clientY - rect.y + camera.y)
    			};
    		}
    		if (['mousedown', 'touchstart'].indexOf(event.type) !== -1) {
    			self.selectedGameObjectAtPosition(mousePosition);
    			if (self.selectedGameObject) {
    				offset = {
    					x: mousePosition.x - self.selectedGameObject.transform.position.x,
    					y: mousePosition.y - self.selectedGameObject.transform.position.y
    				};
    			} else {
    				offset = mousePosition;
    			}
    			stageCanvas.isMoving = true;
    		} else if (['mouseup', 'touchend'].indexOf(event.type) !== -1) {
    			stageCanvas.isMoving = false;
    		}
    		if (stageCanvas.isMoving) {
    			if (self.selectedGameObject) {
    				self.selectedGameObject.transform.position.x = mousePosition.x - offset.x;
    				self.selectedGameObject.transform.position.y = mousePosition.y - offset.y;
    			} else {
    				camera.x -= mousePosition.x - offset.x;
    				camera.y -= mousePosition.y - offset.y;
    			}
    			self.updateNewStage();
    		}
    	};
    	stageCanvas.addEventListener('mousedown', move, {passive: true});
    	stageCanvas.addEventListener('touchstart', move, {passive: true});
    	stageCanvas.addEventListener('mousemove', move, {passive: true});
    	stageCanvas.addEventListener('touchmove', move, {passive: true});
    	document.addEventListener('mouseup', move, true);
    	document.addEventListener('touchend', move, true);
    	Util.ondrop(stageCanvas, (event) => {
    		var file = event.dataTransfer.getData("x-gamefile/prefab");
    		if (file) {
    			file = JSON.parse(file);
    			this.scene.gameObjects.push(file.data);
    		}
    	});
    },
    updateNewStage: function () {
    	if (this.isFilePrefab) return;
      if (this.isUpdateRequested) return;
      this.isUpdateRequested = true;
      window.requestAnimationFrame(() => {
        this.isUpdateRequested = false;
        var stageCanvas = this.stageCanvas;
        var camera = this.camera;
        var tilemapViewer = this.tilemapViewer;
        var scene = this.scene;
        var stageCtx = this.stageCtx;
      	var renderArea = {
      		x: Math.round(camera.x),
      		y: Math.round(camera.y),
      		width: stageCanvas.width,
      		height: stageCanvas.height
      	};
      	stageCtx.clearRect(0, 0, stageCanvas.width, stageCanvas.height);
      	this.goMap = [];
      	tilemapViewer.onready = () => {
      		this.updateNewStage();
      	};
      	this.renderGameObjects(scene.gameObjects.filter(go => go.transform.position.z < 0));
      	if (tilemapViewer.tilemap && tilemapViewer.pixSize) {
      		stageCtx.drawImage(tilemapViewer.getLayerCanvas(2, renderArea), 0, 0);
      		stageCtx.drawImage(tilemapViewer.getLayerCanvas(1, renderArea), 0, 0);
      	}
      	stageCtx.strokeStyle = '#fff';
      	this.renderGameObjects(scene.gameObjects.filter(go => go.transform.position.z >= 0));
      	if (tilemapViewer.tilemap && tilemapViewer.pixSize) {
      		stageCtx.drawImage(tilemapViewer.getLayerCanvas(0, renderArea), 0, 0);
      	}
      	stageCtx.strokeStyle = '#fff';
      	stageCtx.strokeRect(-camera.x, -camera.y, scene.width, scene.height);
      	stageCtx.fillStyle = '#f00';
      	stageCtx.fillRect(-camera.x, -camera.y, 40, 1);
      	stageCtx.fillStyle = '#0f0';
      	stageCtx.fillRect(-camera.x, -camera.y, 1, 40);
      });
    },
    renderGameObjects: function (gameObjects) {
      var self = this;
      var updateNewStage = this.updateNewStage;
      var camera = this.camera;
      var stageCtx = this.stageCtx;
      var cacheImages = this.cacheImages;
      gameObjects.forEach(function (gameObject) {
    		if (!gameObject.visible) return;
    		stageCtx.strokeStyle = '#fff';
    		var screenPosition = {
    			x: Math.round(gameObject.transform.position.x - camera.x),
    			y: Math.round(gameObject.transform.position.y - camera.y)
    		};
    		var image;
    		var goWidth = 15;
    		var goHeight = 15;
    		if (gameObject.animator.asset) {
    			image = cacheImages[gameObject.animator.asset];
    			if (image) {
    				if (gameObject.animator.spritesheet) {
    					var spritesheet = GameStudio.getFileById(gameObject.animator.spritesheet).data;
    					var coordIndex = spritesheet.animations[gameObject.animator.defaultAnimation || spritesheet.defaultAnimation][0];
    					var frame = [coordIndex % spritesheet.columns, Math.floor(coordIndex/spritesheet.columns)];
    					var offset = gameObject.animator.offset || {x: 0, y: 0};
    					var x = (frame[0] + offset.x) * spritesheet.frameWidth;
    					var y = (frame[1] + offset.y) * spritesheet.frameHeight;
    					image = Util.sliceImageAsCanvas(image, x, y, spritesheet.frameWidth, spritesheet.frameHeight);
    				}
    				goWidth = image.width * gameObject.transform.scale.x;
    				goHeight = image.height * gameObject.transform.scale.y;

    				if (gameObject.transform.rotation.z) {
    					var translate = {
    						x: Math.round(screenPosition.x + goWidth / 2),
    						y: Math.round(screenPosition.y + goHeight / 2)
    					};
    					stageCtx.translate(translate.x, translate.y);
    					stageCtx.rotate(gameObject.transform.rotation.z * Math.PI / 180);
    					stageCtx.translate(-translate.x, -translate.y);
    				}
    				if (gameObject.transform.rotation.x) {
    					var divX = Math.trunc(gameObject.transform.rotation.x/180);
    					var restX = (gameObject.transform.rotation.x%180)/180;
    					var scaleX = UtilMath.lerp(1, -1, restX) * (divX % 2 ? -1 : 1);
    					var translateX = -scaleX * (goHeight + screenPosition.y) + screenPosition.y + (1-Math.abs((scaleX - 1)/2)) * goHeight;
    					stageCtx.translate(0, translateX);
    					stageCtx.scale(1, scaleX);
    				}
    				if (gameObject.transform.rotation.y) {
    					var divY = Math.trunc(gameObject.transform.rotation.y/180);
    					var restY = (gameObject.transform.rotation.y%180)/180;
    					var scaleY = UtilMath.lerp(1, -1, restY) * (divY % 2 ? -1 : 1);
    					var translateY = -scaleY * (goWidth + screenPosition.x) + screenPosition.x + (1-Math.abs((scaleY - 1)/2)) * goHeight;
    					stageCtx.translate(translateY, 0);
    					stageCtx.scale(scaleY, 1);
    				}
    				stageCtx.drawImage(image, 0, 0, image.width, image.height, screenPosition.x, screenPosition.y, goWidth, goHeight);
    				stageCtx.setTransform(1, 0, 0, 1, 0, 0);
    			} else {
    				var fileData = self.assets[gameObject.animator.asset];
    				if (fileData && typeof cacheImages[gameObject.animator.asset] === 'undefined') {
    					cacheImages[gameObject.animator.asset] = null;
    					Util.loadImageSrc(fileData, function (image) {
    						cacheImages[gameObject.animator.asset] = image;
    						updateNewStage();
    					});
    				}
    			}
    		}
    		if (!gameObject.locked) {
    			stageCtx.strokeRect(screenPosition.x, screenPosition.y, goWidth, goHeight);
    			self.goMap.push({
    				x: screenPosition.x,
    				y: screenPosition.y,
    				width: goWidth,
    				height: goHeight,
    				gameObject: gameObject
    			});
    		}
    		if (self.selectedGameObject === gameObject) {
    			stageCtx.fillStyle = '#f00';
    			stageCtx.fillRect(screenPosition.x, screenPosition.y, goWidth, 1);
    			stageCtx.fillStyle = '#0f0';
    			stageCtx.fillRect(screenPosition.x, screenPosition.y, 1, goHeight);
          if (gameObject.collider) {
            stageCtx.strokeStyle = '#03a9f4';
            stageCtx.fillStyle = 'rgba(3, 169, 244, 0.2)';
            stageCtx.fillRect(screenPosition.x + gameObject.collider.x * goWidth, screenPosition.y + gameObject.collider.y * goHeight, gameObject.collider.width * goWidth, gameObject.collider.height * goHeight);
            stageCtx.strokeRect(screenPosition.x + gameObject.collider.x * goWidth, screenPosition.y + gameObject.collider.y * goHeight, gameObject.collider.width * goWidth, gameObject.collider.height * goHeight);
          }
    			if (gameObject.light) {
    				stageCtx.lineWidth = 1;
    				stageCtx.strokeStyle = '#ffc107';
    				stageCtx.fillStyle = 'rgba(255, 193, 7, 0.2)';
    				var screenPositionLight = {
    					x: screenPosition.x + (image ? goWidth * gameObject.light.position.x : 0),
    					y: screenPosition.y + (image ? goHeight * gameObject.light.position.y : 0)
    				};
    				switch (gameObject.light.type) {
    					case 'Point':
    						stageCtx.beginPath();
    						stageCtx.arc(Math.round(screenPositionLight.x), Math.round(screenPositionLight.y), Math.round(gameObject.light.params.r1), 0, 2 * Math.PI);
    						stageCtx.fill();
    						stageCtx.arc(Math.round(screenPositionLight.x), Math.round(screenPositionLight.y), Math.round(gameObject.light.params.r2), 0, 2 * Math.PI);
    						stageCtx.stroke();
    						break;
    					case 'Spot':
    						//
    						break;
    					case 'Area':
    						stageCtx.beginPath();
    						stageCtx.rect(Math.round(screenPositionLight.x), Math.round(screenPositionLight.y), Math.round(gameObject.light.params.width), Math.round(gameObject.light.params.height));
    						stageCtx.fill();
    						stageCtx.stroke();
    						break;
    				}
    			}
    		}
    	});
    },
    selectedGameObjectAtPosition: function (position) {
    	var screenPosition = {
    		x: Math.round(position.x - this.camera.x),
    		y: Math.round(position.y - this.camera.y)
    	};
    	var foundMap = this.goMap.find(m => m.x <= screenPosition.x && m.x + m.width >= screenPosition.x && m.y <= screenPosition.y && m.y + m.height >= screenPosition.y);
    	this.selectedGameObject = foundMap ? foundMap.gameObject : null;
    	this.selectedGameObjectIndex = this.scene.gameObjects.indexOf(this.selectedGameObject);
      this.updateNewStage();
    },
    focusGameObject: function (gameObject) {
      var container = this.$el.querySelector('.stage-container');
      this.camera.x = gameObject.transform.position.x - container.clientWidth/2;
      this.camera.y = gameObject.transform.position.y - container.clientHeight/2;
      this.updateNewStage();
    }
  },
  mounted: function () {
    var self = this;
    var tilesets = GameStudio.getFilesWithExtensions(['.tileset']).toIdData();
    this.$store.previewUpdate = function () {
    	var canvas = self.$el.querySelector('.stage-container canvas');
    	if (!canvas) return;
    	if (canvas.width !== window.innerWidth || canvas.height !== window.innerHeight) {
    		self.createNewStage();
    	}
    };
    if (this.isFilePrefab) {
  		this.selectedGameObject = this.fileData.data;
  		return;
  	}
  	Util.cacheAssets(this.assets).then((cache) => {
  		this.cacheImages = cache;
  		this.tilemapViewer = new TilemapViewer({tilesets: tilesets, assetsCache: this.cacheImages});
  		this.createNewStage();
  	});
  },
  beforeUnmount: function () {
    console.log('Destroy');
    this.$store.previewUpdate = null;
  }
}
</script>

<style lang="css" scoped>
.component.mapEditor .container {
	overflow: hidden;
}
.game-object-list .option {
	display: flex;
	align-items: center;
}
.game-object-list .option span {
	width: 100%;
}
.game-object-list .option i {
	width: 24px;
}
</style>
